import { CanActivateFn, Route, Router } from '@angular/router';
import { map } from 'rxjs';
import { inject } from '@angular/core';
import { UserService } from '@app/shared/services/user.service';
import { administrationGuard } from '@shared/guards/administrationGuard';
import { UserType } from '@shared/models/user';
import { Access } from '@shared/models/access';
import { deregistrationsGuard } from '@shared/guards/deregistrations.guard';
import { dataImportGuard } from '@shared/guards/data-import.guard';
import { pickUpGuard } from '@shared/guards/pick-up.guard';
import { verifiedTransportGuard } from '@shared/guards/verified-transport.guard';

export const redirectToLandingPage: CanActivateFn = () => {
  const { fetchUser$ } = inject(UserService);
  const router = inject(Router);
  const rootUrls: Record<UserType, string[]> = {
    PARTNER: ['home'],
    FLEET_OWNER: ['deregistrations', 'verified-transport'],
    DEALER: ['verified-transport'],
    TRANSPORT_COMPANY: ['verified-transport']
  }

  const routeAccessCheck: Record<string, ( access: Access ) => boolean> = {
    ['home']: ( access: Access ) => access.pickUp,
    ['deregistrations']: ( access: Access ) => access.deregistrations,
    ['verified-transport']: ( access: Access ) => access.verifiedTransport
  } as const;


  return fetchUser$.pipe(
    map(( user ) => {
      const routeCandidates = rootUrls[user.userType];

      const routeTarget = routeCandidates.find(route => {
        const checker = routeAccessCheck[route]
        return checker ? checker(user.access) : false;
      });

      return router.parseUrl('/' + (routeTarget ?? 'not-found'));
    }
    ));
}

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [redirectToLandingPage],
    children: []
  },
  {
    path: 'deregistrations',
    loadChildren: () => import('./deregistrations/deregistrations.routes'),
    canActivate: [deregistrationsGuard]
  },
  {
    path: 'data-import',
    loadChildren: () => import('./data-import/data-import.routes'),
    canActivate: [dataImportGuard]
  },
  {
    path: 'verified-transport',
    loadChildren: () => import('@app/verified-transport-v2/verified-transport.routes'),
    canActivate: [verifiedTransportGuard]
  },
  {
    path: 'administration',
    loadChildren: () => import('@app/administration-v2/administration-v2.routes'),
    canActivate: [administrationGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component'),
    canActivate: [pickUpGuard]
  },
  {
    path: 'scan-license-plates',
    loadChildren: () => import('./scan-license-plates/scan-license-plates.routes'),
    canActivate: [pickUpGuard]
  },
  {
    path: 'not-found',
    loadComponent: () => import('@rs-shared-lib/components/not-found/not-found.component'),
  },
  {
    path: '**',
    redirectTo: ''
  }
];
